// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0531b530","453":"234de0a0","455":"3fedc303","977":"4e089eb3"}[chunkId] + ".chunk.js";
};